import { render, staticRenderFns } from "./SchoolTeacherList.vue?vue&type=template&id=ef92148c&scoped=true"
import script from "./SchoolTeacherList.vue?vue&type=script&lang=js"
export * from "./SchoolTeacherList.vue?vue&type=script&lang=js"
import style0 from "./SchoolTeacherList.vue?vue&type=style&index=0&id=ef92148c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef92148c",
  null
  
)

export default component.exports